"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "four"
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: require("@/assets/404.png"),
      alt: ""
    }
  }), _c("span", {
    staticClass: "backHome",
    on: {
      click: _vm.goBack
    }
  }, [_vm._v("返回首页"), _c("van-icon", {
    attrs: {
      name: "share-o"
    }
  })], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;